export enum CardType {
    NormalCard = "NormalCard",
    LinkedCard = "LinkedCard",
}
